import React from "react";

const ExpiredVibesHeader = ({ t }) => (
  <h3 className="text-lg font-bold mt-6 mb-3 px-2 py-1 rounded text-gray-700">
    {t("expired_vibes")}
  </h3>
);

export default ExpiredVibesHeader;
